"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessTableModal = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const react_1 = require("react");
const StickinessTableModalContentTabContent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/table/StickinessTableModalContentTabContent");
require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/stickinessTableModal.less");
const modalButtonsPropsInitialValue = {
    cancel: { disabled: false },
};
const StickinessTableModal = (props) => {
    const [modalButtonProps, setModalButtonProps] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), modalButtonsPropsInitialValue);
    const onCancel = () => {
        props.onDestroy();
    };
    return React.createElement(antd_1.Modal, { footer: [React.createElement(antd_1.Button, { key: "ok", onClick: onCancel, type: "primary" }, "Ok")], width: "80%", closable: true, maskClosable: true, destroyOnClose: true, visible: props.visible, title: props.title, onCancel: onCancel, cancelButtonProps: modalButtonProps.cancel, className: "ug-modal retentionTableModal stickinessTableModal" },
        React.createElement("br", null),
        React.createElement(StickinessTableModalContentTabContent_1.StickinessTableModalContentTabContent, { lineType: props.lineType }));
};
exports.StickinessTableModal = StickinessTableModal;
